module.exports = __webpack_public_path__ + "static/media/aura.a7c7545e.png";